var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"justify-center"},[_c('v-col',{staticClass:"py-0",attrs:{"cols":"12","lg":"10","xl":"8"}},[_c('v-skeleton-loader',{attrs:{"type":"card-heading, list-item@3"}})],1),_c('v-col',{staticClass:"py-0 mb-6",attrs:{"cols":"12","lg":"10","xl":"8"}},[_c('v-skeleton-loader',{attrs:{"type":"card-heading, list-item@6, actions"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }